import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigManagerService } from '@xpo-ltl/config-manager';

import { XpoShellRoute } from '@xpo-ltl/ngx-ltl-core/shell';
import _ from 'lodash';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { XpoShellRouteSecure } from '../app.component';
import { AppRouteLabels, AppRoutes } from '../enums/app-routes.enum';
import { ConfigManagerProperties } from '../enums/config-manager-properties.enum';
import { RamRolesPermissions } from '../enums/user-permission.enum';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionService {
  userPermissions = new BehaviorSubject<Array<string>>(undefined);
  userPermissions$ = this.userPermissions.asObservable();
  ramRoles = new BehaviorSubject<string[]>(undefined);
  ramRoles$ = this.ramRoles.asObservable();
  _isProduction = false;
  userLoaded$ = new BehaviorSubject<boolean>(false);
  validRoutes: Array<any>;
  private readonly removeDomainRegExp = /.*\//gm;

  constructor(
    private userService: UserService,
    private router: Router,
    private configManagerService: ConfigManagerService
  ) {
    this._isProduction = this.configManagerService.getSetting<boolean>(ConfigManagerProperties.production);
  }

  hasRamRolePermission(permission: string): Observable<boolean> {
    return of(this.isRouteAuthorized(permission));
  }

  isRouteAuthorized(permission: string): boolean {
    const permissionConfig = RamRolesPermissions[permission];

    if (permissionConfig?.allowAll) {
      return true;
    }
    const ramRolesUser = this._isProduction ? permissionConfig?.User : permissionConfig?.testUser;
    return ramRolesUser?.allowedRoles.some((role) => this.ramRoles?.value?.includes(role)) ?? false;
  }

  routeUserBasedOnPermission(permissionsBasedRoutes: XpoShellRoute[]) {
    if (permissionsBasedRoutes.some((route) => route.label === AppRouteLabels.dynamicRules)) {
      this.router.navigate([`${AppRoutes.DYNAMIC_RULE}/${AppRoutes.LIST_PAGE}`]);
    } else {
      this.router.navigate([`${AppRoutes.NOT_AUTHORIZED_PAGE}`]);
    }
  }

  getUserRoutes(routes: XpoShellRouteSecure[]): XpoShellRoute[] {
    return routes
      ?.filter((route: XpoShellRouteSecure) => {
        if (!route.children) {
          return !route.permission || this.isRouteAuthorized(route.permission);
        } else {
          const child = route.children.filter(
            (children: any) => !children.permission || this.isRouteAuthorized(children.permission)
          );
          return !!child.length;
        }
      })
      .map((route: XpoShellRouteSecure) => {
        return {
          label: route.label,
          path: route.path,
          children: route.children
            ? route.children.filter(
                (children: any) => !children.permission || this.isRouteAuthorized(children.permission)
              )
            : null,
        };
      });
  }

  getRamRoles(userRoles: string[]) {
    return _.map(userRoles, (role: string) => {
      return role.replace(this.removeDomainRegExp, '');
    });
  }
}
